import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5289e699"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd__elm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "hd__elm-balance"
}
const _hoisted_4 = { class: "hd__elm-balance-label" }
const _hoisted_5 = {
  key: 2,
  class: "hd__elm-channels"
}
const _hoisted_6 = { class: "hd__elm-channels-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd__elm-profile-label" }, "Профиль", -1))
const _hoisted_8 = {
  key: 4,
  class: "hd__elm-profile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLogo = _resolveComponent("IconLogo")!
  const _component_IconLogoTapi = _resolveComponent("IconLogoTapi")!
  const _component_IconBalance = _resolveComponent("IconBalance")!
  const _component_IconChannels = _resolveComponent("IconChannels")!
  const _component_IconProfile = _resolveComponent("IconProfile")!
  const _component_ModalHeaderProfile = _resolveComponent("ModalHeaderProfile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "hd",
      style: _normalizeStyle(
			_ctx.isAuth
				? '--template-columns: auto 50px 100px 100px 100px'
				: '--template-columns: 1fr 120px'
		)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "hd__elm-logo",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoToHomepage && _ctx.onGoToHomepage(...args)))
        }, [
          (_ctx.vue_app_theme === _ctx.THEMES)
            ? (_openBlock(), _createBlock(_component_IconLogo, { key: 0 }))
            : (_openBlock(), _createBlock(_component_IconLogoTapi, { key: 1 }))
        ]),
        (_ctx.isAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "hd__elm-profile-label hd__elm-profile-label_api",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openApiUrlHandler && _ctx.openApiUrlHandler(...args)))
              }, " API ")
            ]))
          : _createCommentVNode("", true),
        (
					_ctx.isAuth &&
					!_ctx.isAdmin &&
					undefined !== _ctx.tariffType &&
					1 !== _ctx.tariffType
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_IconBalance),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.balance), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_IconChannels),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.channels), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAuth)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "hd__elm-profile",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickProfile && _ctx.onClickProfile(...args)))
            }, [
              _createVNode(_component_IconProfile),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isAuth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_IconProfile),
              (_ctx.currentRoute === _ctx.LOGIN)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickLogin && _ctx.onClickLogin(...args))),
                    class: "hd__elm-profile-label"
                  }, " Войти "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 4),
    (_ctx.modalProfile.isShow)
      ? (_openBlock(), _createBlock(_component_ModalHeaderProfile, {
          key: 0,
          "tariff-type": _ctx.tariffType
        }, null, 8, ["tariff-type"]))
      : _createCommentVNode("", true)
  ], 64))
}